import { createContext } from 'react';
import { IWebsocketContext } from './types';

const WebsocketContext = createContext<IWebsocketContext>({} as IWebsocketContext);

export default WebsocketContext;
